import React, { createContext, useCallback, useContext, useRef, useState } from "react";

/**
 * One quiet toast at the bottom of the screen. Confirmation only — errors belong inline next to
 * the control that failed, where the user can act on them.
 */
const ToastContext = createContext<(message: string) => void>(() => {});

export function useToast(): (message: string) => void {
    return useContext(ToastContext);
}

export const ToastProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const [message, setMessage] = useState<string>();
    const timer = useRef<number>();

    const show = useCallback((m: string) => {
        setMessage(m);
        window.clearTimeout(timer.current);
        timer.current = window.setTimeout(() => setMessage(undefined), 2000);
    }, []);

    return (
        <ToastContext.Provider value={show}>
            {children}
            <div
                aria-live="polite"
                className={`fixed bottom-7 left-1/2 z-50 -translate-x-1/2 rounded-[12px] bg-[var(--text)] px-5 py-3 text-[13.5px] font-semibold text-[var(--app)] shadow-[0_16px_40px_rgba(0,0,0,.35)] transition-all duration-150 ${
                    message ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-2 opacity-0"
                }`}
            >
                {message}
            </div>
        </ToastContext.Provider>
    );
};
